export const ANALYSIS_NOTIFICATION_STORAGE_KEY_PREFIX =
  "tcbase_url_notification_shown_";
